var _defs, _rect, _g, _path, _path2, _g2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdateCvBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1297 507",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-17{fill:none;}.cls-2{fill:#edeefc;}.cls-3{fill:#dcdcf5;}.cls-4{clip-path:url(#clip-path);}.cls-5{fill:#e9a4b3;}.cls-6{fill:#233862;}.cls-7{fill:#00a7ff;}.cls-8{fill:#d998a9;}.cls-9{fill:#22d696;}.cls-10{fill:#2c3a64;}.cls-11{fill:#6e3d3d;}.cls-12{clip-path:url(#clip-path-2);}.cls-13{fill:#ab5654;}.cls-14{fill:#fff;}.cls-15{fill:#acaae2;opacity:0.25;isolation:isolate;}.cls-16{fill:#040227;}.cls-17{stroke:#c5c9f6;stroke-linecap:round;stroke-linejoin:round;stroke-width:8px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1093.56,66.88a.49.49,0,0,1,.54.42h0v0a4.39,4.39,0,0,1-2.19,3.71c-2.61,1.67-6.41,1.48-8.42-.1a5.57,5.57,0,0,1-1.4-2.52.44.44,0,0,1,.32-.53h.1Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1121.62,57.2a.48.48,0,0,1,.55.42v0a4.46,4.46,0,0,1-2.23,3.8c-2.68,1.72-6.56,1.52-8.61-.1a5.64,5.64,0,0,1-1.43-2.58.44.44,0,0,1,.31-.53l.11,0Z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Surface-2",
    className: "cls-2",
    x: 8.32,
    y: 70.03,
    width: 1280,
    height: 423,
    rx: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1135",
    "data-name": "Group 1135"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1136",
    "data-name": "Group 1136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1133",
    "data-name": "Group 1133"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2056",
    "data-name": "Path 2056",
    className: "cls-3",
    d: "M1086.23,152.94a12,12,0,0,1-.43,1.28c-6.19,17.45-17.22,35.77-24.75,42.46-4.94,4.43-18.51,9-30.06,12.29-7.66,2.25-14.5,3.88-17.31,4.59-.89.23-1.41.32-1.41.32l-2.57-7.6s6-3.75,13.31-8.67c10.15-6.9,22.85-16,25.28-19.89,5.63-9.08,9.37-36.83,14.19-55.57.24-1,.49-2,.74-3,.18-.71.37-1.4.56-2.08a1.64,1.64,0,0,1,.17-.5c.26-.78.46-1.49.68-2.13,0-.06,0-.13.1-.21a57.49,57.49,0,0,1,3.26-7.46c1.41-2.19,2.94-3.26,4.61-2.9a20.75,20.75,0,0,1,5.18,2.69,23.58,23.58,0,0,1,1.9,1.43,5.21,5.21,0,0,1,1.1.94,27.65,27.65,0,0,1,6.5,8.7,34,34,0,0,1,3,10.39C1091.22,134.77,1089.43,143.69,1086.23,152.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2084",
    "data-name": "Path 2084",
    className: "cls-3",
    d: "M1077.16,26.23c7.68-4,19.37-4.58,21.27-4.84,22.73-3.05,36.4,30,37.21,40,1.49,18.44,11.24,21.25,25,32.8,27.53,23.17,19.46,50.08,4.4,60.08-9,6-25,0-25,0-.23.16-43.55-24.22-64.91-36C1043.14,113.71,1057.58,36.51,1077.16,26.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2053",
    "data-name": "Path 2053",
    className: "cls-3",
    d: "M1063.56,478.57l8.67,3.23s37.66-52.23,42.3-98.19a69.74,69.74,0,0,0-1.24-23.49s.37-2.1,1-5.82c.3-1.73.67-3.83,1.09-6.22,1.22-7,2.91-16.62,4.83-27.54,4.43-25.15,10.17-57.3,14.63-80.94l-2.34-.75-25.28-8.16L1102,214.1l-18.83-5s-4.2,8.23-8,47.08c-.69,5.1-1.32,10.72-1.8,16.82a333,333,0,0,0,1.79,68.06q1.3,10.13,3.31,20.89c1,5.25,1.14,12.41.72,20.63C1077.34,420.19,1063.56,478.57,1063.56,478.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2054",
    "data-name": "Path 2054",
    className: "cls-3",
    d: "M1073.42,273l40.87,81.26c.3-1.73.67-3.83,1.09-6.22,1.22-7,2.91-16.62,4.83-27.54,4.43-25.15,10.18-57.3,14.63-80.94l-2.34-.75-25.27-8.16L1102,214.1l-18.82-5s-4.21,8.23-8,47.08C1074.53,261.32,1073.9,266.94,1073.42,273Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2055",
    "data-name": "Path 2055",
    className: "cls-3",
    d: "M1091.4,219.57l.95-8.11c15.85,4.21,58.2-11.77,58.2-11.77s15.36,13.5,13.34,45.86c-1,15.79-2.78,82.91-4.66,102.77-.67,7.2-1.27,12.32-1.51,14.36v0a2.88,2.88,0,0,0,.46,1.76A92.65,92.65,0,0,1,1165.1,379c18.43,49.1-2.83,109.58-2.83,109.58l-5.52-2.22s-12.1-67.3-21.94-97a58.66,58.66,0,0,0-4.73-11.38c-4.28-6.9-8.25-18.17-11.85-31.58-6.8-25.36-12.28-58.34-15.93-83.8C1101.8,262.63,1091.4,219.57,1091.4,219.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2057",
    "data-name": "Path 2057",
    className: "cls-3",
    d: "M1077.64,121.09a49.41,49.41,0,0,0,17.45,6.86c26.76,5.39,36.32-17.36,39.7-32.89a22.88,22.88,0,0,0-9.09-2.52c-1.92-.17-4-.26-5.62-.3-3-2.2-7.76-11.43-9.15-25.93l-1.25.37L1088.89,73s1.15,6.63,1.8,12.91c.5,4.92.7,9.62-.21,10.8-1.62.4-2.6.66-2.6.66v0A135.74,135.74,0,0,0,1077.64,121.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2058",
    "data-name": "Path 2058",
    className: "cls-3",
    d: "M1088.9,73s1.15,6.63,1.8,12.92c11.83-1.53,17-13,19-19.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2059",
    "data-name": "Path 2059",
    className: "cls-3",
    d: "M1085.53,79.35s28.13-2.35,26.4-19.84.73-29.58-17.3-28.82-20.86,7.78-21.7,13.76S1078.17,79.52,1085.53,79.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2060",
    "data-name": "Path 2060",
    className: "cls-3",
    d: "M1063.22,119.2c.18-.71.37-1.4.56-2.08a1.64,1.64,0,0,1,.17-.5c.26-.78.47-1.49.68-2.13,0-.06,0-.14.1-.22a57.36,57.36,0,0,1,3.26-7.45c1-1.58,2-3,3.17-3.49.89-.55,5.77-3.4,16.73-6v0c-.28.65-7.77,17.72-6.53,21.77s37.55-3.33,39.84-5.9c1.84-2.06,3.64-14.12,4.28-18.83.16-1.17.25-1.89.25-1.89s13.12.12,19.93,4.1a56,56,0,0,0-5.8,12.48c-.19.64-.37,1.28-.53,1.92a25.91,25.91,0,0,0-.7,4.09,7.92,7.92,0,0,0,1.78,5.26,38.39,38.39,0,0,0,4.56,5.06c1.2,1.16,2.48,2.38,3.81,3.7h0c-1,8.07-3.54,21.24-4.1,35.6a24.09,24.09,0,0,0,2,10.56,25,25,0,0,0,2,3.81c6.36,9.63,17.38,28.58,12.88,38.72-1.67,9.95-87.71,10.85-84.32.15,0,0-3.8-62.77-8.5-78.48-.17-.57-.32-1.13-.44-1.7-1.31-6-.17-11.74,1.29-16.87A29.58,29.58,0,0,0,1063.22,119.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2062",
    "data-name": "Path 2062",
    className: "cls-3",
    d: "M1102.89,200.8c16.62,2.23,33.17-13,43.76-25.49a24.07,24.07,0,0,1-2-10.56c.56-14.36,3-27.53,4.1-35.6h0c-1.33-1.32-2.62-2.54-3.81-3.7a38.39,38.39,0,0,1-4.56-5.06C1123.46,141.39,1080.35,197.77,1102.89,200.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2064",
    "data-name": "Path 2064",
    className: "cls-3",
    d: "M1130.18,493.13h43.68s1-6.66-1.24-11.71c-2.18-4.84-5.61-7-4.79-12.91-2.77,2.86-7.3,6.06-13.61,5.21-.78,1.25-5,8-7.58,9.82C1143.79,485.59,1131.06,484.86,1130.18,493.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2065",
    "data-name": "Path 2065",
    className: "cls-3",
    d: "M1036.42,493.13h43.67s1.63-7-1.23-11.71c-2.54-4.19-1.57-6.58.31-10.05a16.94,16.94,0,0,1-7.36,1.39,15.5,15.5,0,0,1-6.49-2.29c-1.88,2.14-9.93,11.27-12.44,13.07C1050,485.59,1037.3,484.86,1036.42,493.13Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2080",
    "data-name": "Path 2080",
    className: "cls-3",
    d: "M1044.9,206.49l1.55,8.57s2.92-.27,7.58-.73c1.4-.14,2.2-.27,2.2-.27,3.72-.4,8.19-1,13-1.63h.07c8.34-1.25,17.7-2.81,25.63-4.75a69,69,0,0,0,13.85-4.79,7.31,7.31,0,0,0,1-.58c8.13-4.89,18.64-20.44,27.22-37.35,1.19-2.34,2.32-4.68,3.44-7a179.43,179.43,0,0,0,9.6-24.2,69.7,69.7,0,0,0,2.8-11.68,28.47,28.47,0,0,0,.35-3.33c0-.6.09-1.2.11-1.76-3.29-2.88-10.86-8.26-21.2-7.7l-.64,1.13c-4.46,8.11-9.33,18.68-13.93,29.22-2.55,5.77-5,11.55-7.46,16.87-1.4,3.24-2.78,6.28-4.08,9.06a89.92,89.92,0,0,1-6.6,12.27c-1.21,1.74-4.43,4-8.67,6.56a295.72,295.72,0,0,1-27.28,13.84c-3.85,1.77-7.48,3.37-10.49,4.69C1048.11,205.13,1044.9,206.49,1044.9,206.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2081",
    "data-name": "Path 2081",
    className: "cls-3",
    d: "M1131.5,110.5c12.88-2.37,21.74,8.29,21.74,8.29,1.48-18.94-7.71-22.35-7.71-22.35C1141.87,94.55,1136.91,100.73,1131.5,110.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2087",
    "data-name": "Path 2087",
    className: "cls-3",
    d: "M1071.42,38.12s19.8,17.05,33.28,18.42,18.57-2.95,18.57-2.95a52.31,52.31,0,0,1-12.72-17.22,9.46,9.46,0,0,0-7.81-5.57C1093.13,30,1074.89,29.59,1071.42,38.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2183-3",
    "data-name": "Path 2183-3",
    className: "cls-3",
    d: "M1093.56,66.88a.5.5,0,0,1,.54.42h0v0a4.39,4.39,0,0,1-2.19,3.71c-2.61,1.67-6.41,1.49-8.42-.1a5.57,5.57,0,0,1-1.4-2.52.44.44,0,0,1,.32-.53h.1Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_728-3",
    "data-name": "Group 728-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1132",
    "data-name": "Group 1132"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1131",
    "data-name": "Group 1131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_727-3",
    "data-name": "Group 727-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2184-3",
    "data-name": "Path 2184-3",
    className: "cls-3",
    d: "M1095.51,69.64a13.71,13.71,0,0,0-6.69-.59,6,6,0,0,0-3.22,1.3c-1.23,1.09-1.33,2.64.13,3.56a4.67,4.67,0,0,0,1.17.56,7,7,0,0,0,2.5.22,9.49,9.49,0,0,0,5.74-2,2,2,0,0,0,.82-1.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2185-3",
    "data-name": "Path 2185-3",
    className: "cls-3",
    d: "M1091.84,66.11c.26.1.28.9.12,1.1a1.43,1.43,0,0,1-.7.36,23.52,23.52,0,0,1-6.69.72,2.39,2.39,0,0,1-.65-.06.9.9,0,0,1-.66-.72,2.77,2.77,0,0,1,.1-.81"
  }))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2083",
    "data-name": "Path 2083",
    className: "cls-3",
    d: "M1027.21,215.67c2.31,3.12,8.4,7.9,16.26,4.25a125.43,125.43,0,0,1,14.54-5.37c1.16-.3,1.82-.5,1.82-.5l-3.72-9.09a2,2,0,0,1-.39.13c-2,.57-12.13.61-17.68,3.57C1031.62,212.1,1024.5,212,1027.21,215.67Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2083-2",
    "data-name": "Path 2083-2",
    className: "cls-5",
    d: "M1010.31,208.23c2.36,3.2,8.59,8.08,16.63,4.35a128.5,128.5,0,0,1,14.86-5.5c1.19-.3,1.86-.51,1.86-.51l-3.8-9.29a1.87,1.87,0,0,1-.4.13c-2.08.58-12.41.62-18.08,3.66C1014.82,204.58,1007.53,204.47,1010.31,208.23Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1134",
    "data-name": "Group 1134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1133-2",
    "data-name": "Group 1133-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2056-2",
    "data-name": "Path 2056-2",
    className: "cls-5",
    d: "M1114.13,145.21a12.59,12.59,0,0,1-.44,1.31c-6.34,17.85-17.62,36.59-25.32,43.43-5,4.52-18.93,9.21-30.74,12.57-7.83,2.3-14.83,4-17.7,4.69-.91.23-1.44.32-1.44.32l-2.63-7.77s6.13-3.83,13.61-8.86c10.39-7.06,23.37-16.35,25.86-20.35,5.75-9.28,9.57-37.66,14.51-56.82.25-1,.5-2,.75-3,.19-.73.38-1.43.57-2.13a2.21,2.21,0,0,1,.18-.51c.27-.8.48-1.52.7-2.18,0-.06,0-.14.1-.22a58.59,58.59,0,0,1,3.33-7.62c1.44-2.24,3-3.34,4.72-3a21.3,21.3,0,0,1,5.29,2.75c.67.45,1.32.94,2,1.46a5.17,5.17,0,0,1,1.12,1,28,28,0,0,1,6.65,8.9,34.64,34.64,0,0,1,3.08,10.62C1119.23,126.63,1117.4,135.75,1114.13,145.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2084-2",
    "data-name": "Path 2084-2",
    className: "cls-6",
    d: "M1104.85,15.62c7.86-4.13,19.82-4.68,21.76-4.94,23.24-3.13,37.23,30.65,38.05,40.88,1.52,18.87,11.49,21.74,25.54,33.55,28.17,23.69,19.9,51.22,4.5,61.44-9.24,6.14-25.52,0-25.52,0-.23.16-44.54-24.77-66.38-36.8C1070.06,105.1,1084.83,26.13,1104.85,15.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2053-2",
    "data-name": "Path 2053-2",
    className: "cls-7",
    d: "M1090.94,478.24l8.87,3.3s38.51-53.42,43.26-100.42a71.38,71.38,0,0,0-1.27-24s.38-2.15,1-5.95c.3-1.77.69-3.91,1.11-6.35,1.26-7.18,3-17,5-28.17,4.53-25.73,10.4-58.61,15-82.78l-2.39-.77-25.86-8.34-5.34-17L1111,202.69s-4.3,8.41-8.14,48.15c-.71,5.21-1.36,11-1.84,17.2a340.33,340.33,0,0,0,1.83,69.61q1.32,10.37,3.38,21.36c1,5.38,1.17,12.69.74,21.1C1105,418.53,1090.94,478.24,1090.94,478.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2054-2",
    "data-name": "Path 2054-2",
    className: "cls-7",
    d: "M1101,268l41.8,83.1c.3-1.77.68-3.91,1.11-6.36,1.25-7.17,3-17,4.94-28.17,4.53-25.72,10.4-58.6,15-82.78l-2.39-.76-25.85-8.34-5.34-17L1111,202.69s-4.3,8.41-8.15,48.15C1102.16,256.05,1101.51,261.8,1101,268Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2055-2",
    "data-name": "Path 2055-2",
    className: "cls-7",
    d: "M1119.42,213.36l1-8.3c16.21,4.31,59.53-12,59.53-12s15.71,13.81,13.65,46.9c-1,16.15-2.85,84.79-4.77,105.1-.69,7.36-1.3,12.6-1.55,14.69v0a2.93,2.93,0,0,0,.48,1.8,94.6,94.6,0,0,1,7.08,14.91c18.85,50.22-2.9,112.07-2.9,112.07l-5.64-2.27s-12.38-68.83-22.43-99.24a60.41,60.41,0,0,0-4.85-11.63c-4.37-7.06-8.43-18.59-12.11-32.3-7-25.93-12.56-59.66-16.29-85.7C1130.05,257.39,1119.42,213.36,1119.42,213.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2057-2",
    "data-name": "Path 2057-2",
    className: "cls-5",
    d: "M1105.34,112.64a50.36,50.36,0,0,0,17.85,7c27.37,5.51,37.14-17.75,40.6-33.64a23.42,23.42,0,0,0-9.29-2.57c-2-.18-4-.27-5.76-.31-3.12-2.25-7.94-11.69-9.36-26.52l-1.27.38-21.26,6.46s1.18,6.79,1.84,13.21c.51,5,.71,9.84-.21,11l-2.66.67v0A138.27,138.27,0,0,0,1105.34,112.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2058-2",
    "data-name": "Path 2058-2",
    className: "cls-8",
    d: "M1116.85,63.46s1.18,6.78,1.84,13.21c12.1-1.56,17.41-13.28,19.43-19.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2059-2",
    "data-name": "Path 2059-2",
    className: "cls-5",
    d: "M1113.41,70s28.77-2.4,27-20.29.75-30.26-17.69-29.48-21.34,8-22.2,14.08S1105.88,70.12,1113.41,70Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2060-2",
    "data-name": "Path 2060-2",
    className: "cls-9",
    d: "M1090.59,110.71c.19-.73.38-1.43.57-2.14a2.3,2.3,0,0,1,.18-.5c.27-.8.48-1.52.7-2.18,0-.06,0-.14.1-.22a58.59,58.59,0,0,1,3.33-7.62c1-1.62,2.1-3,3.25-3.57.9-.56,5.9-3.47,17.11-6.1l0,0c-.28.66-7.94,18.13-6.67,22.27s38.4-3.41,40.74-6c1.88-2.12,3.72-14.45,4.37-19.27.17-1.2.26-1.93.26-1.93s13.42.13,20.39,4.2a57.28,57.28,0,0,0-5.94,12.77c-.19.65-.38,1.3-.54,2a25.71,25.71,0,0,0-.71,4.18,8.12,8.12,0,0,0,1.81,5.38,39.51,39.51,0,0,0,4.67,5.17c1.22,1.19,2.54,2.44,3.9,3.78h0c-1.07,8.26-3.62,21.73-4.19,36.42a24.71,24.71,0,0,0,2,10.8,26.14,26.14,0,0,0,2.1,3.9c6.51,9.85,17.77,29.23,13.17,39.6-1.7,10.17-89.7,11.09-86.23.15,0,0-3.89-64.2-8.69-80.26-.17-.59-.32-1.16-.45-1.74-1.34-6.11-.18-12,1.32-17.26A29.76,29.76,0,0,0,1090.59,110.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2062-2",
    "data-name": "Path 2062-2",
    className: "cls-9",
    d: "M1131.17,194.16c17,2.29,33.93-13.25,44.75-26.06a24.77,24.77,0,0,1-2-10.8c.57-14.69,3.12-28.16,4.19-36.42h0c-1.36-1.34-2.68-2.6-3.9-3.78a40.09,40.09,0,0,1-4.67-5.17C1152.2,133.4,1108.11,191.07,1131.17,194.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2064-2",
    "data-name": "Path 2064-2",
    className: "cls-10",
    d: "M1159.08,493.12h44.66s1.07-6.8-1.26-12c-2.24-5-5.74-7.2-4.9-13.2-2.84,2.92-7.46,6.2-13.92,5.32-.8,1.29-5.11,8.15-7.75,10.05C1173,485.42,1160,484.67,1159.08,493.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2065-2",
    "data-name": "Path 2065-2",
    className: "cls-10",
    d: "M1063.18,493.13h44.66s1.67-7.13-1.26-12c-2.6-4.29-1.6-6.74.32-10.28a17.34,17.34,0,0,1-7.52,1.41,15.78,15.78,0,0,1-6.64-2.33c-1.92,2.19-10.16,11.52-12.73,13.36C1077.1,485.42,1064.08,484.68,1063.18,493.13Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_90-2",
    "data-name": "Group 90-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2080-2",
    "data-name": "Path 2080-2",
    className: "cls-5",
    d: "M1071.85,200l1.6,8.76,7.74-.74c1.43-.14,2.25-.27,2.25-.27,3.81-.42,8.37-1,13.35-1.67h.06c8.54-1.28,18.1-2.88,26.23-4.87a69.81,69.81,0,0,0,14.16-4.9,8.33,8.33,0,0,0,1-.59c8.32-5,19.06-20.9,27.84-38.2,1.22-2.38,2.37-4.78,3.51-7.1a184.88,184.88,0,0,0,9.83-24.74,72,72,0,0,0,2.85-11.94,28,28,0,0,0,.36-3.41c.05-.62.09-1.22.12-1.81-3.37-2.94-11.12-8.44-21.69-7.87l-.66,1.15c-4.55,8.3-9.53,19.11-14.24,29.89-2.6,5.9-5.14,11.81-7.63,17.25-1.43,3.31-2.85,6.42-4.17,9.27a92.93,92.93,0,0,1-6.75,12.55c-1.23,1.78-4.53,4.12-8.87,6.71a300.38,300.38,0,0,1-27.9,14.15c-3.93,1.81-7.64,3.44-10.72,4.8C1075.14,198.58,1071.85,200,1071.85,200Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2081-2",
    "data-name": "Path 2081-2",
    className: "cls-9",
    d: "M1160.42,101.81c13.18-2.43,22.24,8.48,22.24,8.48,1.51-19.37-7.89-22.86-7.89-22.86C1171,85.49,1166,91.81,1160.42,101.81Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2087-2",
    "data-name": "Path 2087-2",
    className: "cls-6",
    d: "M1099,27.78s20.26,17.44,34,18.85,19-3,19-3A53.65,53.65,0,0,1,1139,26a9.71,9.71,0,0,0-8-5.71C1121.18,19.45,1102.53,19.06,1099,27.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2183-3-2",
    "data-name": "Path 2183-3-2",
    className: "cls-11",
    d: "M1121.62,57.2a.49.49,0,0,1,.55.43h0a4.46,4.46,0,0,1-2.23,3.8c-2.68,1.72-6.56,1.52-8.61-.1a5.66,5.66,0,0,1-1.43-2.57.44.44,0,0,1,.31-.54l.11,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_728-3-2",
    "data-name": "Group 728-3-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1132-2",
    "data-name": "Group 1132-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1131-2",
    "data-name": "Group 1131-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_727-3-2",
    "data-name": "Group 727-3-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2184-3-2",
    "data-name": "Path 2184-3-2",
    className: "cls-13",
    d: "M1123.62,60a14.35,14.35,0,0,0-6.85-.6,6.33,6.33,0,0,0-3.29,1.34c-1.25,1.11-1.36,2.7.14,3.65a4.7,4.7,0,0,0,1.2.56,7.07,7.07,0,0,0,2.55.23,9.7,9.7,0,0,0,5.87-2.06,2.06,2.06,0,0,0,.84-1.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2185-3-2",
    "data-name": "Path 2185-3-2",
    className: "cls-14",
    d: "M1119.87,56.41c.26.1.28.92.12,1.12a1.52,1.52,0,0,1-.72.38,23.89,23.89,0,0,1-6.84.73,2.42,2.42,0,0,1-.66-.06.94.94,0,0,1-.68-.74,2.9,2.9,0,0,1,.1-.83"
  })))))))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2137",
    "data-name": "Path 2137",
    className: "cls-15",
    d: "M856.9,268.08a23.42,23.42,0,0,1-5.2-.77,15.24,15.24,0,0,0-18.83,10.47,15.39,15.39,0,0,0-.56,3.51l-1.1,31.36a15.13,15.13,0,0,0,14.6,15.66l31.12,1.1a15,15,0,0,1,14.63,15.38,15.39,15.39,0,0,1-.4,3.1,23,23,0,0,0-.75,5.09c-.54,15.47,14.14,28.54,32.79,29.19s34.2-11.35,34.75-26.81a23.83,23.83,0,0,0-.38-5.13A15,15,0,0,1,970,333a14.73,14.73,0,0,1,3.11-.18l31.12,1.09a15.15,15.15,0,0,0,15.66-14.6l1.1-31.13a15,15,0,0,1,15.39-14.62,15.2,15.2,0,0,1,3.08.4,23.51,23.51,0,0,0,5.07.74c15.46.54,28.53-14.13,29.19-32.78s-11.35-34.21-26.82-34.76a23.65,23.65,0,0,0-5.1.38,15,15,0,0,1-17.24-12.39,16,16,0,0,1-.18-3.09l1.1-31.13a15.14,15.14,0,0,0-14.6-15.67l-31.5-1.1a15.18,15.18,0,0,1-13.94-19.5,23.28,23.28,0,0,0,.89-5.63c.54-15.47-14.13-28.54-32.78-29.19s-34.21,11.35-34.76,26.81a23.55,23.55,0,0,0,.49,5.68A15.15,15.15,0,0,1,884,140.78l-31.51-1.1a15.13,15.13,0,0,0-15.66,14.6l-1.09,31A15.27,15.27,0,0,0,853.64,201a23.82,23.82,0,0,1,5.65-.49c15.46.55,27.47,16.1,26.81,34.76S872.36,268.62,856.9,268.08Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2138",
    "data-name": "Path 2138",
    className: "cls-16",
    d: "M841,250.58a23.42,23.42,0,0,1-5.2-.77A15.22,15.22,0,0,0,817,260.27a15,15,0,0,0-.57,3.52l-1.11,31.36a15.15,15.15,0,0,0,14.6,15.66l31.13,1.1a15,15,0,0,1,14.62,15.39,14.7,14.7,0,0,1-.4,3.09,23.6,23.6,0,0,0-.74,5.09c-.55,15.46,14.13,28.54,32.78,29.19s34.21-11.35,34.76-26.81a23.22,23.22,0,0,0-.39-5.13,15,15,0,0,1,12.39-17.24,15.29,15.29,0,0,1,3.1-.19l31.12,1.1A15.14,15.14,0,0,0,1004,301.8l1.1-31.13a15,15,0,0,1,15.4-14.62,14.52,14.52,0,0,1,3.08.4,23.33,23.33,0,0,0,5.06.74c15.47.54,28.54-14.14,29.19-32.79s-11.35-34.2-26.81-34.75a23.55,23.55,0,0,0-5.1.37,15,15,0,0,1-17.24-12.38,14.64,14.64,0,0,1-.18-3.1l1.1-31.12A15.16,15.16,0,0,0,995,127.75l-31.51-1.11a15.17,15.17,0,0,1-13.93-19.49,24,24,0,0,0,.89-5.63C951,86.05,936.27,73,917.62,72.32s-34.2,11.35-34.75,26.82a23.59,23.59,0,0,0,.49,5.68,15.17,15.17,0,0,1-11.51,18.11,15,15,0,0,1-3.77.36l-31.51-1.11a15.14,15.14,0,0,0-15.66,14.6l-1.09,31a15.23,15.23,0,0,0,17.94,15.73,23.3,23.3,0,0,1,5.65-.48c15.46.54,27.47,16.1,26.81,34.75S856.5,251.12,841,250.58Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-file-text-2",
    "data-name": "Icon feather-file-text-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2046-2",
    "data-name": "Path 2046-2",
    className: "cls-17",
    d: "M954.28,167.12H913.35a10.23,10.23,0,0,0-10.23,10.23h0v81.87a10.23,10.23,0,0,0,10.23,10.23h61.4A10.23,10.23,0,0,0,985,259.22h0v-61.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2047-2",
    "data-name": "Path 2047-2",
    className: "cls-17",
    d: "M954.28,167.12v30.7H985"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2048-2",
    "data-name": "Path 2048-2",
    className: "cls-17",
    d: "M964.52,223.4H923.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2049-2",
    "data-name": "Path 2049-2",
    className: "cls-17",
    d: "M964.52,243.87H923.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2050-2",
    "data-name": "Path 2050-2",
    className: "cls-17",
    d: "M933.82,202.94H923.58"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2083-3",
    "data-name": "Path 2083-3",
    className: "cls-5",
    d: "M1045.77,209.37c2.36,3.2,8.59,8.07,16.63,4.35a126.68,126.68,0,0,1,14.86-5.5c1.19-.3,1.86-.51,1.86-.51l-3.8-9.3a1.9,1.9,0,0,1-.4.14c-2.08.58-12.41.62-18.08,3.65C1050.28,205.72,1043,205.61,1045.77,209.37Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateCvBanner);
export default __webpack_public_path__ + "static/media/update-cv-banner.ead7d51909ae82d1c2bb9cba4eec3956.svg";
export { ForwardRef as ReactComponent };